import { render, staticRenderFns } from "./DEP.vue?vue&type=template&id=46fac7ae&scoped=true&"
import script from "./DEP.vue?vue&type=script&lang=js&"
export * from "./DEP.vue?vue&type=script&lang=js&"
import style0 from "./DEP.vue?vue&type=style&index=0&id=46fac7ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fac7ae",
  null
  
)

export default component.exports